module.exports = __webpack_public_path__ + "static/oxford2hh-9b2f73b2923d7eccef74f4c9999174c6.jpg";